import React, { useEffect, useState } from "react";
import ExaminationList from "./examination-list/ExaminationList";
import FormList from "./form-list/FormList";
import StudentReportList from "./student-report-list/StudentReportList";
import { Spin, Typography } from "antd";
import styles from "./report-card-management.module.css";
import { useAcademicYears } from "../../../hooks/useAcademicYear";
import { fetchTerms } from "../../../services/school_info";
import { createAntdSelection } from "../../../utils/common";
import ECDProgramToggle from "./ecd-program-toggle/ecd-program-toggle";

const ReportCardManagement = () => {
  const [currentStep, setCurrentStep] = useState("examinations");
  const [selectedExam, setSelectedExam] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const [isECDProgram, setIsECDProgram] = useState(false);
  const {
    selectedYear,
    selectedYearName,
    loading
  } = useAcademicYears();
  const [terms, setTerms] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState("");

  useEffect(() => {
    if (isECDProgram && selectedYear) {
      getTerms();
    }
  }, [isECDProgram, selectedYear]);

  const getTerms = async () => {
    try {
      const params = {
        academic_year_id: selectedYear,
      };
      const resp = await fetchTerms(params);
      const data = resp?.data?.data?.terms;
      const selectable = createAntdSelection(data);
      setTerms(selectable);

      const activeTerm = data?.find(t => t?.is_active);
      setSelectedTerm(
        activeTerm?.id || selectable[0]?.value || null
      );
    } catch (err) {
      console.log(err);
    }
  };

  const goToForms = (exam) => {
    setSelectedExam(exam);
    setCurrentStep("forms");
  };

  const goToStudents = (form) => {
    setSelectedForm(form);
    setCurrentStep("students");
  };

  const goBack = () => {
    if (currentStep === "students") setCurrentStep("forms");
    else if (currentStep === "forms") setCurrentStep("examinations");
  };

  const updateECDProgram = (enable) => {
    setIsECDProgram(enable);
    setCurrentStep(enable ? "forms" : "examinations");
    setSelectedExam(null);
  };

  return (
    <Spin spinning={loading}>
      <Typography.Title level={5}>
        Report Card Management
        <p className={styles.yearText}>
          Academic Year: {selectedYearName}
        </p>
      </Typography.Title>
      
      <ECDProgramToggle
        isECDProgram={isECDProgram}
        updateECDProgram={updateECDProgram}
      />

      {currentStep === "examinations" && (
        <ExaminationList 
          onViewDetails={goToForms} 
          selectedYear={selectedYear}
        />
      )}
      {currentStep === "forms" && (
        <FormList
          exam={selectedExam}
          onViewDetails={goToStudents}
          onClick={goBack}
          isECDProgram={isECDProgram}
          selectedYear={selectedYear}
          termList={terms}
          selectedTerm={selectedTerm}
          setSelectedTerm={setSelectedTerm}
        />
      )}
      {currentStep === "students" && (
        <StudentReportList
          form={selectedForm}
          onClick={goBack}
          exam={selectedExam}
          isECDProgram={isECDProgram}
          selectedTerm={selectedTerm}
        />
      )}
    </Spin>
  );
};

export default ReportCardManagement;
